<template>
  <div>
    <CCard class="bg-style2">
      <CCardHeader
          class="bg-gradient-danger text-white"
          style="border-top-left-radius: 1rem; border-top-right-radius: 1rem"
      >
        <span class="font-weight-bold h6">
          <CIcon class="mr-2" v-if="icon" :name="icon" />
          {{ caption }}
        </span>
      </CCardHeader>
      <CCardBody class="pb-0">
        <CRow>
          <!-- Status Filter -->
          <CCol class="col-12 col-md">
            <CRow class="mb-3">
              <CCol>
                <label>STATUS</label>
                <Multiselect
                    class="os"
                    v-model="select.status"
                    :options="statusOptions"
                    label="label"
                    track-by="value"
                    :multiple="false"
                    :searchable="true"
                    placeholder="Select status"
                />
              </CCol>
            </CRow>
          </CCol>

          <!-- Role Filter -->
          <CCol class="col-12 col-md">
            <CRow class="mb-3">
              <CCol>
                <label>ROLE</label>
                <Multiselect
                    class="os"
                    v-model="select.role"
                    :options="roleOptions"
                    label="label"
                    track-by="value"
                    :multiple="false"
                    :searchable="true"
                    placeholder="Select role"
                />
              </CCol>
            </CRow>
          </CCol>

          <!-- Candidate Type Filter -->
          <CCol class="col-12 col-md">
            <CRow class="mb-3">
              <CCol>
                <label>CANDIDATE TYPE</label>
                <Multiselect
                    class="os"
                    v-model="select.userType"
                    :options="typeOptions"
                    label="label"
                    track-by="value"
                    :multiple="false"
                    :searchable="true"
                    placeholder="Select type"
                />
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import { mapGetters } from 'vuex'

export default {
  name: 'FilterOptions',
  components: { Multiselect },
  props: {
    icon: {
      type: String,
      default: 'cil-magnifying-glass'
    },
    caption: {
      type: String,
      default: 'ตัวกรอง'
    }
  },
  data() {
    return {
      select: {
        status: null,
        role: null,
        userType: null
      }
    }
  },
  computed: {
    ...mapGetters({
      statusOptions: 'dropdown/formattedStatuses',
      roleOptions: 'dropdown/formattedRoles',
      typeOptions: 'dropdown/formattedTypes'
    })
  },
  watch: {
    select: {
      deep: true,
      handler() {
        this.$emit('filter-changed', this.select)
      }
    }
  },
  async mounted() {
    await this.$store.dispatch('dropdown/fetchAllDropdowns')
  }
}
</script>

<style scoped>
.os {
  min-width: 220px;
  width: 100%;
}
@media (max-width: 576px) {
  .os {
    min-width: 100%;
  }
}
</style>
